export default ` 
  {
    suggestedReportedCount {
      count
    }
  }
`;